export default ` 
  {
    suggestedReportedCount {
      count
    }
  }
`;